import { useEffect, useState } from 'react';
import { NotificationState } from '../types';
import { NOTIFICATION_DURATION } from '../constants';

interface TabletopNotificationProps {
  notification: NotificationState | null;
  onClear: () => void;
}

export default function TabletopNotification({ 
  notification, 
  onClear 
}: TabletopNotificationProps) {
  const [visible, setVisible] = useState(false);

  const dismiss = () => {
    setVisible(false);
    window.setTimeout(onClear, 220);
  };

  useEffect(() => {
    if (notification) {
      setVisible(true);
      const timer = setTimeout(() => {
        dismiss();
      }, NOTIFICATION_DURATION);
      
      return () => clearTimeout(timer);
    }
  }, [notification, onClear]);

  if (!notification) return null;

  const getIcon = () => {
    if (notification.type === 'success') {
      return (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      );
    } else {
      return (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      );
    }
  };

  return (
    <div 
      className={`fixed left-1/2 top-4 z-[100] min-w-[260px] -translate-x-1/2 rounded-2xl border shadow-xl backdrop-blur-xl transition-all duration-300 ${
        visible ? 'opacity-100 translate-y-0' : 'pointer-events-none opacity-0 -translate-y-3'
      } ${
        notification.type === 'success' 
          ? 'border-emerald-400/30 bg-emerald-500/82 text-white'
          : notification.type === 'info'
            ? 'border-blue-400/30 bg-blue-500/82 text-white'
            : 'border-rose-400/30 bg-rose-500/82 text-white'
      }`}
    >
      <div className="flex items-center px-4 py-3">
        <div className="mr-3">
          {getIcon()}
        </div>
        <p className="font-medium">{notification.message}</p>
        <button 
          onClick={dismiss} 
          className="ml-3 text-white/80 hover:text-white transition-colors"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
} 
